const totalUserCommissionsPercentageIsValid = (commissions) => {
  let validateCommissions = true
  if (commissions && commissions.length > 0) {
    validateCommissions = commissions.every((commission) => parseFloat(commission.commissionPercent) <= 100)
  }
  return validateCommissions
}

export default totalUserCommissionsPercentageIsValid
